import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'
import { NO_NUMBERS } from 'constants/regex'
import { InputProps } from 'components/inputs/types'
import { getFieldError, getFieldName } from 'components/inputs/utils'

const LastName = ({ hiddenLabel, parentDotPath, required = true, grid, readonly }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  return (
    <TextField
      {...{ grid, hiddenLabel, readonly }}
      {...register(getFieldName('lastName', parentDotPath), {
        maxLength: {
          value: 40,
          message: t(($) => $.max.string, {
            attribute: t(($) => $.lastName),
            length: 40,
            ns: 'validation'
          })
        },
        required: {
          value: required,
          message: t(($) => $.required, { ns: 'validation' })
        },
        pattern: {
          value: NO_NUMBERS,
          message: t(($) => $.noNumbers, {
            attribute: t(($) => $.lastName),
            ns: 'validation'
          })
        }
      })}
      error={getFieldError('lastName', parentDotPath, errors)?.message}
      label={t(($) => $.lastName)}
      {...(!required && { optionalText: t(($) => $.optional, { ns: 'common' }) })}
    />
  )
}

export default LastName
